import {JsonProperty} from '@hyperloris/tyson';
import {ApiValidation} from "./api-validation";

export class ApiFileUploadRequest {

  file: File = undefined;

  @JsonProperty()
  fileName: string | undefined;

  @JsonProperty()
  base64FileContent: string | undefined;
}

